import type { CSSProperties, FC, ReactNode } from 'react'

import { Fragment } from 'react'
import { cn } from '@/lib/utils'

interface SplitWordsProps {
    text: string
    /** Offsets the stagger index, so several lines can share one sequence. */
    start?: number
    className?: string
    wordClassName?: string
}

/**
 * Splits copy into masked words. The parent decides when they rise:
 * `data-reveal="words"` (on scroll) or the `load-words` class (on page load).
 */
export const SplitWords: FC<SplitWordsProps> = ({ text, start = 0, className, wordClassName }): ReactNode => {
    const words = text.split(' ').filter(Boolean)

    return (
        <span className={className}>
            {words.map((word, index) => (
                <Fragment key={`${word}-${index}`}>
                    <span className={cn('sw', wordClassName)}>
                        <span style={{ '--i': index + start } as CSSProperties}>
                            {word}
                        </span>
                    </span>
                    {index < words.length - 1 ? ' ' : null}
                </Fragment>
            ))}
        </span>
    )
}
